import React from 'react';
import Home from '@component/gridgio/source/home';
import PageTemplate from '@page/gridgio/page-template';
import * as color from '@constant/color';

const HomePage: React.FC = () => (
  <PageTemplate customHeader='none' title='도면 관리' mode='page' backgroundColor={color.GRAY_BACKGROUND_COLOR}>
    <Home />
  </PageTemplate>
);
export default HomePage;
